const types = {
  SET_BILLING_TYPE: "SET_BILLING_TYPE",
  SET_PAYMENT_TYPE: "SET_PAYMENT_TYPE",
  SET_PAYMENT_INTERVAL: "SET_PAYMENT_INTERVAL",
  RESET_STATE: "RESET_STATE",
  TOGGLE_AVERAGE_AMOUNT: "TOGGLE_AVERAGE_AMOUNT",
  IS_STRIPE_SEPA_DEBIT: "IS_STRIPE_SEPA_DEBIT",
};

export default types;
